"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsBase = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const Constants_1 = require("../Constants");
class OperationsBase {
    constructor(_options) {
        this._options = _options;
    }
    async sendGetRequest(params) {
        return this._options.restClient.sendGetRequest({
            url: params.url,
            headers: await this.formHeaders(params)
        });
    }
    async sendPostRequest(params) {
        return this._options.restClient.sendPostRequest({
            url: params.url,
            body: params.body,
            headers: await this.formHeaders({ ...params, containsBody: true })
        });
    }
    async sendPatchRequest(params) {
        return this._options.restClient.sendPatchRequest({
            url: params.url,
            body: params.body,
            headers: await this.formHeaders({ ...params, containsBody: true })
        });
    }
    async sendDeleteRequest(params) {
        return this._options.restClient.sendDeleteRequest({
            url: params.url,
            headers: await this.formHeaders(params)
        });
    }
    async getEntityCollectionPage(params) {
        const response = await this.sendGetRequest(params);
        return {
            entities: params.entityCollectionAccessor(response),
            next: response._links.next
                ? async () => this.getEntityCollectionPage({ ...params, url: response._links.next.href })
                : undefined
        };
    }
    async formHeaders(params) {
        const headers = {};
        const authorizationInfo = await params.authorization();
        headers[Constants_1.Constants.headers.authorization] = `${authorizationInfo.scheme} ${authorizationInfo.token}`;
        headers[Constants_1.Constants.headers.accept] = `application/vnd.bentley.${this._options.api.version}+json`;
        if (params.preferReturn)
            headers[Constants_1.Constants.headers.prefer] = `return=${params.preferReturn}`;
        if (params.containsBody)
            headers[Constants_1.Constants.headers.contentType] = Constants_1.Constants.headers.values.contentType;
        return headers;
    }
}
exports.OperationsBase = OperationsBase;
//# sourceMappingURL=OperationsBase.js.map